export default "__VITE_ASSET__CE4weNC8__"